import React from "react";
import { FaCheck, FaUserPlus, FaUsers } from "react-icons/fa";

import {
  DEFAULT_AVATAR,
  getFullName,
  getPhotoUrl,
} from "../utils/judokaProfileUtils";

function JudokaSelector({ adherents, selectedId, onSelect, onAdd }) {
  if (!adherents.length) return null;

  return (
    <div className="mb-6 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaUsers />
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
              Profils gérés
            </p>

            <p className="font-titre text-xl font-bold text-slate-950 dark:text-white">
              {adherents.length} judoka{adherents.length > 1 ? "s" : ""} lié
              {adherents.length > 1 ? "s" : ""} à ce compte
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onAdd}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-4 py-2 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5 active:translate-y-0"
        >
          <FaUserPlus />
          Ajouter un judoka
        </button>
      </div>

      <div className="mt-4 flex gap-3 overflow-x-auto pb-1">
        {adherents.map((item) => {
          const isActive = item.id === selectedId;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item.id)}
              className={`flex min-w-[220px] items-center gap-3 rounded-[1.4rem] border p-3 text-left transition ${
                isActive
                  ? "border-orange-300 bg-orange-50 shadow-lg shadow-orange-500/10 dark:border-orange-400/30 dark:bg-orange-500/10"
                  : "border-slate-200 bg-slate-50 hover:bg-white hover:shadow-md dark:border-white/10 dark:bg-white/[0.04] dark:hover:bg-white/[0.08]"
              }`}
            >
              <img
                src={getPhotoUrl(item)}
                alt={getFullName(item)}
                className="h-12 w-12 rounded-2xl object-cover"
                onError={(event) => {
                  event.currentTarget.src = DEFAULT_AVATAR;
                }}
              />

              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-bold text-slate-950 dark:text-white">
                  {getFullName(item)}
                </p>

                <p className="truncate text-xs font-semibold text-slate-500 dark:text-white/50">
                  {item.club || item.genre || "Profil judoka"}
                </p>
              </div>

              {isActive && <FaCheck className="shrink-0 text-orange-500" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default JudokaSelector;